<template lang="">
    <div @click="goMatch(match._id)" class="match-table-row">
      
      <!-- Time Column -->
      <div class="table-cell cell-time">
        <span class="match-time">{{ moment(dateTime).format('h:mm A') }}</span>
        <span class="match-date">{{ moment(dateTime).format('MMM D') }}</span>
      </div>

      <!-- Teams Column -->
      <div class="table-cell cell-teams">
        <div class="teams-container">
          <!-- Home Team -->
          <div class="team-row">
            <div class="team-logo">
              <TeamLogo :team="homeTeam" :small="true" v-if="!matchIsVs(match)" :competitionId="match.competition"/>
              <TeamLogoVs :team="homeTeam" :small="true" v-if="matchIsVs(match)" />
            </div>
            <span class="team-name notranslate">{{get(homeTeam, 'name', meta && !!meta.isBye ? 'BYE' : 'TBA')}}</span>
          </div>
          
          <!-- VS Divider -->
          <div class="vs-divider">vs</div>
          
          <!-- Away Team -->
          <div class="team-row">
            <div class="team-logo">
              <TeamLogo :team="awayTeam" :small="true" v-if="!matchIsVs(match)"  :competitionId="match.competition"/>
              <TeamLogoVs :team="awayTeam" :small="true" v-if="matchIsVs(match)" />
            </div>
            <span class="team-name notranslate">{{get(awayTeam, 'name', meta && !!meta.isBye ? 'BYE' : 'TBA')}}</span>
          </div>
          <!-- <span class="c-yellow f-bold text-center">{{ match.round.displayName || (match.round.type === 'Final' ? (match.round.number === 1 ? 'Semi Final' : 'Final') : 'Round ' + (match.round.name || match.round.number)) }}</span> -->
        </div>
      </div>

      <!-- Score Column -->
      <div class="table-cell cell-score">
        <div class="score-container">
          <span class="home-score">{{getScore('homeTeam', scoringEvents, scores,status,meta,homeTeam, competitionId)}}</span>
          <span class="score-separator">-</span>
          <span class="away-score">{{getScore('awayTeam', scoringEvents, scores,status,meta,awayTeam, competitionId)}}</span>
        </div>
      </div>

      <!-- Status Column -->
      <div class="table-cell cell-status">
        <ion-badge 
          v-if="match.currentSetId && status === 'sets'"
          color="light"
          class="status-badge in-progress">
          <div class="status-dot"></div>
          <span>Set {{ match.currentSetId }}</span>
        </ion-badge>
        <ion-badge 
          v-else-if="status === 'first-half' || status === 'second-half'"
          :color="gameStatusColor(status)" 
          class="status-badge in-progress">
          <div class="status-dot"></div>
          <span>{{ upperCase(status).replace('FIRST', '1st').replace('SECOND', '2nd').replace('PENALTY', 'Penalties') }}</span>
        </ion-badge>
        <ion-badge v-else :color="gameStatusColor(status)" class="status-badge">
          <ion-icon v-if="checkForfeit('homeTeam',status,meta,homeTeam)" :icon="arrowBackOutline"></ion-icon>
          <span>{{ upperCase(status) }}</span>
          <ion-icon v-if="checkForfeit('awayTeam',status,meta,awayTeam)" :icon="arrowForwardOutline"></ion-icon>
        </ion-badge>
      </div>

      <!-- Venue Column -->
      <div class="table-cell cell-venue">
        <span class="venue-name notranslate">{{get(venue, 'name', 'TBA')}}</span>
        <span class="field-name notranslate" v-if="fieldDisplayName(get(meta, 'field'))">{{fieldDisplayName(get(meta, 'field'))}}</span>
        <span class="field-name notranslate" v-if="get(match, 'matchName')">{{get(match, 'matchName')}}</span>
        <span class="field-name notranslate" v-if="get(match, 'pool.name')">{{get(match, 'pool.name')}}</span>
      </div>

    </div>
  </template>
  
<script>
import _ from 'lodash';
import moment from 'moment';
import TeamLogo from '../views/matches/base/team-logo.vue'
import TeamLogoVs from '../views/matches/base/team-logo-vs.vue';
  
export default {
  name: 'MatchCard',
  props: {
    match: {
      type: Object,
      required: true
    }
  },
  components: {
    TeamLogo,
    TeamLogoVs
  },
  data() {
    return {
      moment,
      upperCase: _.upperCase,
      get: _.get,
      find: _.find,
      venue: this.match.venue,
      meta: this.match.meta,
      scores: this.match.scores,
      scoringEvents: this.match.scoringEvents,
      competitionId: this.match.competition._id,
      weather: this.match.weather,
      homeTeam: this.match.homeTeam,
      awayTeam: this.match.awayTeam,
      dateTime: this.match.dateTime,
      status: this.match.status
    }
  },
  computed: {
    entity() {
      return this.$store.getters['national/getEntity'];
    },
  },  
  methods: {
    fieldDisplayName(field) {
      if (!field || !field.name) return '';
      if (!field.surface || field.surface === 'N/A') return field.name;
      return `${field.name} (${field.surface})`;
    },
    matchIsVs(match) {
      return _.get(match, 'competitionSettings.type') === 'vs';
    },
    checkForfeit(type,status,meta,team){
      if(type === 'homeTeam'){
        if(status === 'forfeit'){
          const isForfeitingTeam = _.get(meta, 'forfeitingTeam.name') === _.get(team, 'name');
          return isForfeitingTeam ? true: false;
        }
        return false;
      }else if( type === 'awayTeam'){
        if(status === 'forfeit') {
          const isForfeitingTeam = _.get(meta, 'forfeitingTeam.name') === _.get(team, 'name');
          return isForfeitingTeam ? true: false;
        }
        return false;
      }
    },
    getScore(type, scoringEvents, scores, status, meta, team, competitionId) {
      const hasPenaltyPeriod = scoringEvents ? scoringEvents.some(ev => ev.name.toLowerCase().includes('penalty') && ev.period === 9999) : false;
      if (type === 'homeTeam' || type === 'awayTeam') {
        // if (status === 'forfeit') {
        //   // const isForfeitingTeam = _.get(meta, 'forfeitingTeam.name') === _.get(team, 'name');
        //   // const competition = _.find(this.competitions, { _id: competitionId });
        //   // return isForfeitingTeam ? 0 : _.get(competition, 'laddertemplate.defaultScoreFFReceived');
        //   // Commented out old code, the this.competitions is not defined in this component
        //   const score = type === 'homeTeam' ? _.get(scores, 'homeTeam', 0) : _.get(scores, 'awayTeam', 0);
        //   return score;
        // }
        if (status === 'penalty' || hasPenaltyPeriod) {
          const mainScore = _.get(scores, `${type}`, 0);
          const penScoreEvents = scoringEvents
            .filter(ev => 
              ev.name.toLowerCase().includes('penalty') &&
            !ev.name.toLowerCase().includes('miss') &&
            ev.teamId === team._id
            );
          const penScore = penScoreEvents
            .reduce((acc, cur) => acc + 1, 0);
          const penScoreValues = penScoreEvents
            .reduce((acc, cur) => acc + cur.value, 0);
          return type === 'homeTeam' ? `(${penScore}) ${mainScore - penScoreValues}` : `${mainScore - penScoreValues} (${penScore})`;
        }
        return _.get(scores, `${type}`, 0);
      }
    },
    getHomeScore(scores,status,meta,homeTeam){
      if(status === 'forfeit'){
        const competition = _.find(this.competitions, { _id: this.competitionId });
        const isForfeitingTeam = _.get(meta, 'forfeitingTeam.name') === _.get(homeTeam, 'name');
        return isForfeitingTeam ? 0 : _.get(competition, 'laddertemplate.defaultScoreFFReceived');
      }
      else{
        return _.get(scores, 'homeTeam', 0);
      }
    },
    getAwayScore(scores,status,meta,awayTeam){
      if(status === 'forfeit'){
        const competition = _.find(this.competitions, { _id: this.competitionId });
        const isForfeitingTeam = _.get(meta, 'forfeitingTeam.name') === _.get(awayTeam, 'name');
        return isForfeitingTeam ? 0 : _.get(competition, 'laddertemplate.defaultScoreFFReceived');
      }
      else{
        return _.get(scores, 'awayTeam', 0);
      }
    },
    isLastIndex(round, index) {
      const nextIndex = index+1;
      if(!this.filteredMatches[nextIndex]) return true;
      return round.number !== this.filteredMatches[nextIndex].round.number;
    },
    getByes(round) {
      const res = _.filter(this.byes, g=> g.round.number === round.number);
      return res;
    },
    // getWeatherIcon(name) {
    //   var images = require.context('../assets/weather-icons/', false, /\.svg$/)
    //   return images('./' + name + ".svg")
    // },
    goMatch(id) {
      console.log('entity', this.entity);
      if(this.entity && this.entity.level && this.entity.name){
        this.$router.push(`/c/${this.entity.level}/${this.entity.name}/matches/${id}`);
        return;
      }
      this.$router.push(`/matches/${id}`);
    },
    goToAS() {
      window.open('https://assemblesports.com', "_blank");
    },
    randomizeAds() {
      const freq = 5;
      const rand =  Math.random();
      return rand  <= (freq / 100);
    },
    segmentChanged(event) {
      this.segment = event.detail.value;
      if(this.segment === 'matches'){
        this.ladderSegment = 'ladderBoard';
      }else{
        this.ladderSegment = 'ladderBoard';
      }
    },
    ladderSegmentChanged(event) {
      this.ladderSegment = event.detail.value;
    },
    setSegment(){
      if (this.filteredMatches.length > 0) this.segment = 'matches';
      else if(Object.keys(this.ladder).length > 0) this.segment = 'ladder';
      else this.segment = 'matches';
    },
    gameStatusColor(status) {
      switch (status) {
      case 'pre-game':
        return 'light';
      case 'final':
        return 'success';
      case 'forfeit':
      case 'washout':
        return 'warning';
      case 'disputed':
      case 'offline':
        return 'danger';
      case 'first-half':
      case 'second-half':
        return 'light';
      default:
        return 'light';
      }
    },
  }
}
</script>
  
  <style lang="scss" scoped>

// Table Row Layout - Enhanced Readability & Professional
.match-table-row {
  display: grid;
  grid-template-columns: 140px 1fr 120px 120px 200px;
  gap: 1rem;
  padding: 1.125rem 1.5rem;
  cursor: pointer;
  
  // Professional row styling with improved readability
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
  color: #f8f9fa;
  
  // Warmer, less blue-tinted separator
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  
  &:hover {
    // Warmer hover with slight cream tint
    background: rgba(255, 252, 245, 0.04);
    border-bottom-color: rgba(255, 255, 255, 0.08);
  }
  
  &:active {
    background: rgba(255, 252, 245, 0.06);
  }
}

// Table cell base styling
.table-cell {
  display: flex;
  align-items: center;
  min-height: 60px;
}

// Time Column
.cell-time {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.2rem;
  
  .match-time {
    color: #ffffff;
    font-size: 0.9rem;
    font-weight: 600;
    letter-spacing: -0.01em;
  }
  
  .match-date {
    color: #b8bcc3;
    font-size: 0.75rem;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }
}

// Teams Column
.cell-teams {
  .teams-container {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    width: 100%;
  }
  
  .team-row {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    
    .team-logo {
      width: 32px;
      height: 32px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      
      // Consistent logo sizing
      ::v-deep img {
        width: 32px !important;
        height: 32px !important;
        object-fit: contain;
      }
    }
    
    .team-name {
      color: #ffffff;
      font-size: 0.875rem;
      font-weight: 500;
      letter-spacing: -0.005em;
      line-height: 1.3;
      
      // Prevent overflow
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 200px;
    }
  }
  
  .vs-divider {
    text-align: center;
    color: #8a8f98;
    font-size: 0.65rem;
    font-weight: 600;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    margin: 0.1rem 0;
  }
}

// Score Column
.cell-score {
  justify-content: center;
  
  .score-container {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    
    .home-score,
    .away-score {
      font-size: 1.1rem;
      font-weight: 700;
      color: #ffffff;
      letter-spacing: -0.01em;
      min-width: 20px;
      text-align: center;
      
      // Gradient effect for scores
      background: linear-gradient(135deg, #ffffff, #e8e8e8);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
    
    .score-separator {
      color: #9ca3af;
      font-size: 0.8rem;
      font-weight: 500;
    }
  }
}

// Status Column
.cell-status {
  justify-content: center;
  
  .status-badge {
    border-radius: 6px;
    height: auto;
    min-height: 1.3rem;
    padding: 0.25rem 0.5rem;
    font-weight: 600;
    font-size: 0.65rem;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    gap: 0.25rem;
    
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    
    &.in-progress {
      background: linear-gradient(135deg, 
        rgba(76, 175, 80, 0.9), 
        rgba(129, 199, 132, 0.9)
      ) !important;
      color: white !important;
      box-shadow: 0 2px 6px rgba(76, 175, 80, 0.3);
    }
    
    .status-dot {
      width: 3px;
      height: 3px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.9);
      animation: pulse 2s infinite;
    }
  }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
}

// Venue Column
.cell-venue {
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 0.2rem;
  
  .venue-name {
    color: #b8bcc3;
    font-size: 0.8rem;
    font-weight: 500;
    letter-spacing: 0.01em;
    text-align: right;
    
    // Text truncation
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 180px;
  }
  
  .field-name {
    color: #8a8f98;
    font-size: 0.7rem;
    font-weight: 400;
    text-align: right;
    
    // Text truncation
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 180px;
  }
}

// Responsive adjustments
@media (max-width: 1200px) {
  .match-table-row {
    grid-template-columns: 120px 1fr 100px 100px 160px;
    gap: 0.75rem;
    padding: 0.875rem 1rem;
  }
  
  .cell-teams .team-row .team-name {
    font-size: 0.8rem;
    max-width: 150px;
  }
  
  .cell-score .score-container {
    .home-score, .away-score {
      font-size: 1rem;
    }
  }
  
  .cell-venue .venue-name,
  .cell-venue .field-name {
    max-width: 140px;
  }
}

@media (max-width: 1024px) {
  .match-table-row {
    grid-template-columns: 100px 1fr 80px 80px 120px;
    gap: 0.5rem;
    padding: 0.75rem 0.75rem;
  }
  
  .table-cell {
    min-height: 50px;
  }
  
  .cell-time {
    .match-time {
      font-size: 0.8rem;
    }
    .match-date {
      font-size: 0.7rem;
    }
  }
  
  .cell-teams .team-row {
    gap: 0.5rem;
    
    .team-logo {
      width: 24px;
      height: 24px;
      
      ::v-deep img {
        width: 20px !important;
        height: 20px !important;
      }
    }
    
    .team-name {
      font-size: 0.75rem;
      max-width: 120px;
    }
  }
  
  .cell-score .score-container {
    .home-score, .away-score {
      font-size: 0.9rem;
    }
  }
  
  .cell-status .status-badge {
    font-size: 0.6rem;
    padding: 0.2rem 0.4rem;
  }
  
  .cell-venue {
    .venue-name {
      font-size: 0.75rem;
      max-width: 100px;
    }
    
    .field-name {
      font-size: 0.65rem;
      max-width: 100px;
    }
  }
}

// Hide table layout on mobile (will use card view)
@media (max-width: 768px) {
  .match-table-row {
    display: none;
  }
}

// Legacy cleanup
.list-ios, .list-md {
  padding: 0;
  background: transparent;
}
  </style>